import { Button } from "@landtechnologies/components";
import { useTranslation } from "react-migration/lib";

type SupportRowProps = {
  onSupportClick: () => void;
  contactPhone?: string;
  contactEmail?: string;
};

export const SupportRow = ({ onSupportClick, contactPhone, contactEmail }: SupportRowProps) => {
  const { t } = useTranslation();
  return (
    <div>
      <div className="atlas-flex atlas-flex-col  atlas-text-sm atlas-font-semibold atlas-mb-1">
        {contactPhone && (
          <>
            <span>{t("nav.nav.to_make_changes")}</span>
            <span>
              {t("nav.nav.phone", {
                phone: (
                  <span className="atlas-text-base atlas-text-content-link atlas-font-semibold">
                    {contactPhone}
                  </span>
                ),
              })}
            </span>
          </>
        )}
        {contactEmail && (
          <span>
            {t("nav.nav.contact_email", {
              email: (
                <a
                  className="atlas-text-base atlas-text-content-link atlas-font-semibold atlas-block"
                  href={`mailto:${contactEmail}`}
                >
                  {contactEmail}
                </a>
              ),
            })}
          </span>
        )}
      </div>
      <Button.Primary onClick={onSupportClick}>{t("nav.nav.chat_to_support")}</Button.Primary>
    </div>
  );
};
